import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { CourseWeb } from "../../types/slices/coursesWebType";
import { useCourseWebStore } from "../../hooks/useCourseWebStore";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { CreateEditCourseWebModal } from "./components/CreateEditCourseWebModal";

const columns = [
  { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "name", label: "CURSO", align: "center" },
  { type: "text", field: "name_teacher", label: "PROFESOR", align: "center" },
  { type: "text", field: "name_category", label: "CATEGORÍA", align: "center" },
  { type: "text", field: "modality", label: "MODALIDAD", align: "center" },
  { type: "text", field: "order", label: "ORDEN", align: "center" },
  { 
    type: "text", 
    field: "status", 
    label: "ESTADO", 
    align: "center",
    format: (row) => (
      row.status === "1" ? "Activo" : row.status === "2" ? "Próximamente" : "Inactivo"
    )
  },
  {
    type: "image",
    field: "image",
    label: "IMAGEN",
    align: "center",
    format: (row) =>
      row.image ? <img src={row.image} alt="logo" width="50px" /> : "",
  },
];

const CoursesWebView: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);
  const [rowSelected, setRowSelected] = useState<CourseWeb>({} as CourseWeb);

  const {
    coursesWeb,
    status,
    openModal,
    getCoursesWeb,
    setOpenModal,
    setEditCourseWeb,
    changeIsEdit,
    deleteCourseWebStore,
    getCoursesWebSearch,
    setSelectedCourseWeb
  } = useCourseWebStore();

  useEffect(() => {
    setLoading(true);
    getCoursesWeb().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditCourseWeb(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getCoursesWebSearch(value);
    }
    if (value.length === 0) {
      getCoursesWeb();
    }
  };

  const onDeleteConfirm = async () => {
    const response = await deleteCourseWebStore(rowSelected?.id || 0);
    if (response === true) {
      setSelectedCourseWeb({} as CourseWeb);
      setModalDeleteConfirm(false);
      getCoursesWeb();
    }
  };

  return (
    <>
      { status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Cursos"}
          columns={columns || []}
          loading={loading}
          rows={coursesWeb || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      { modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={status}
        />
      )}
      {openModal && <CreateEditCourseWebModal />}
    </>
  );
};

export default CoursesWebView;